import { useEffect } from "react";

import { setCMPBannerVisible } from "@/app/actions.mjs";
import { didInitConsent } from "@/feature-consent/consent.mjs";
import globals from "@/util/global-whitelist.mjs";

export function useObserveCMPBannerVisibility() {
  useEffect(() => {
    const movePrivacyManager = () => {
      const appScroller = globals.document?.querySelector(".app-scroller");
      const privacyManager = globals.document?.getElementById(
        "inmobi-injected-link",
      );
      if (
        privacyManager &&
        appScroller &&
        !appScroller.contains(privacyManager)
      ) {
        appScroller.appendChild(privacyManager);
        privacyManager.style.padding = "16px";
      }
    };

    const observer =
      typeof MutationObserver !== "undefined"
        ? new MutationObserver(() => {
            didInitConsent.then(() => {
              setTimeout(() => {
                const cmpVisibility = !!globals.document
                  ?.querySelector(".qc-cmp2-main")
                  ?.hasChildNodes();
                setCMPBannerVisible(cmpVisibility);
                movePrivacyManager();
              }, 500);
            });
          })
        : null;

    if (observer) {
      observer.observe(globals.document.body, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer?.disconnect();
  }, []);
}
